export default "__VITE_ASSET__Bc8VEI65__"